"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Page404",
  methods: {
    backToHome: function backToHome() {
      this.$router.push("/");
    }
  },
  computed: {
    message: function message() {
      return "The webmaster said that you can not enter this page...";
    }
  }
};